"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const IC_X_1 = __importDefault(require("../../assets/icons/IC_X"));
const IconShare_1 = __importDefault(require("../../assets/icons/IconShare"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalShare = (props) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { onClose, visible, onSelect, uri } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    return (react_1.default.createElement(react_native_1.Modal, { statusBarTranslucent: true, visible: visible, animationType: "fade", transparent: true, onRequestClose: props.onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onClose, activeOpacity: 1, style: {
                flex: 1,
                backgroundColor: Colors_1.default.textHeaderOpacity60,
                justifyContent: 'flex-end',
                alignItems: 'center',
            } },
            react_1.default.createElement(react_native_1.View, { style: [
                    {
                        backgroundColor: 'white',
                        width: scale_1.width,
                        position: 'absolute',
                        paddingBottom: insets.bottom + 10,
                        borderTopLeftRadius: (0, scale_1.scale)(16),
                        borderTopRightRadius: (0, scale_1.scale)(16),
                        paddingHorizontal: (0, scale_1.scale)(20),
                    },
                ] },
                react_1.default.createElement(react_native_1.View, { style: {
                        flexDirection: 'row',
                        borderLeftWidth: 6,
                        borderLeftColor: '#287BCF',
                        marginTop: (0, scale_1.verticalScale)(16),
                        paddingLeft: (0, scale_1.scale)(8),
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            color: Colors_1.default.textHeader,
                            fontWeight: '300',
                            lineHeight: (0, scale_1.moderateScale)(24),
                        } }, "\u5171\u6709"),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                            height: (0, scale_1.scale)(30),
                            width: (0, scale_1.scale)(30),
                            // backgroundColor: '#DDDDDD',
                            // borderRadius: 99,
                            // justifyContent: 'center',
                            // alignItems: 'center',
                        }, onPress: onClose },
                        react_1.default.createElement(IC_X_1.default, { height: (0, scale_1.scale)(30), color: '#888888' }))),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: '#292A33',
                        marginTop: (0, scale_1.scale)(16),
                        marginBottom: (0, scale_1.scale)(12),
                    } }, "\u5171\u6709\u65B9\u6CD5"),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        height: (0, scale_1.scale)(60),
                        width: (0, scale_1.scale)(60),
                        borderRadius: (0, scale_1.scale)(5),
                        backgroundColor: '#DDDDDD',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }, onPress: () => {
                        navigator.clipboard.writeText(uri),
                            dispatch(slice_1.default.actions.showToast('リンクをコピーしました')),
                            onClose();
                    } },
                    react_1.default.createElement(IconShare_1.default, null)),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(10),
                        lineHeight: (0, scale_1.moderateScale)(17),
                        color: '#292A33',
                        marginTop: (0, scale_1.scale)(8),
                    } }, "\u30EA\u30F3\u30AF\u30B3\u30D4\u30FC")))));
};
exports.default = ModalShare;
